import Params               from "dashboard/dist/Core/Params";
import { setSection }       from "Actions/Core/CoreActions";
import { LocRoom }          from "Utils/API";

// Types
import {
    LOC_ROOM, LOC_ROOM_LOADING,
    LOC_ROOM_LIST, LOC_ROOM_ELEM,
} from "Utils/Types";



/**
 * Fetches the Room List
 * @param {String=} type
 * @param {Number=} elemID
 * @param {Object=} params
 * @returns {(dispatch) => Void}
 */
export function fetchRooms(type = "", elemID = 0, params = {}) {
    return async (dispatch) => {
        dispatch({ type : LOC_ROOM_LOADING });
        Params.unset(params);
        let data = {};

        switch (type) {
        case "LOCATION":
            params.locationID = elemID;
            data = await LocRoom.getAllForLocation(params);
            break;
        default:
        }
        data.sort = params;
        dispatch({ type : LOC_ROOM_LIST, data });
        dispatch(setSection(LOC_ROOM));
    };
}

/**
 * Fetches a single Room
 * @param {Number} roomID
 * @returns {(dispatch) => Void}
 */
export function fetchRoom(roomID) {
    return async (dispatch) => {
        const data = await LocRoom.getOne({ roomID });
        dispatch({ type : LOC_ROOM_ELEM, data });
    };
}



/**
 * Edits/Creates a Room
 * @param {Object} data
 * @returns {() => Void}
 */
export function editRoom(data) {
    return () => LocRoom.edit(data);
}

/**
 * Deletes a Room
 * @param {Number} roomID
 * @returns {() => Void}
 */
export function deleteRoom(roomID) {
    return () => LocRoom.delete({ roomID });
}
